//
// MaintenanceScreen
//
// Show this when we're doing a migration server-side (/api returns 503s)

import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useStore } from '../stores'

import { Icon } from '../components'
import { SiteScreen } from './SiteScreen'

export const MaintenanceScreen = observer(function MaintenanceScreen(props) {
    const store = useStore()
    const { app } = store

    useEffect(() => {
        function* timeoutBackoffInSecondsGenerator() {
            yield 1
            yield 2
            yield 5
            yield 5
            yield 5
            yield 10
            yield 10
            yield 10
            yield 30
            yield 30
            yield 30
            while (true) {
                yield 60
            }
        }
        const timeoutBackoffInSeconds = timeoutBackoffInSecondsGenerator()

        let timeoutId = null
        const delay = () =>
            new Promise(resolve => {
                const timeoutInSeconds = timeoutBackoffInSeconds.next().value
                timeoutId = setTimeout(() => {
                    timeoutId = null
                    return resolve()
                }, timeoutInSeconds * 1000)
            })

        const ping = () => {
            store.ping().then(response => {
                if (store.in_maintenance) {
                    delay().then(() => ping())
                }
            })
        }

        ping()

        // clear the interval on unmount
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [store])

    return (
        <SiteScreen>
            <div className="avatar">
                <Icon name="unicat" size="fill" title="Unicat" />
            </div>
            <div className="maintenance">
                <h1>{app.text('Unicat Maintenance')}</h1>

                <p>{app.text("We're in the process of making Unicat better.")}</p>
                <p>{app.text('Our apologies for the inconvenience.')}</p>
                <p>{app.text('Please try again later.')}</p>
            </div>
        </SiteScreen>
    )
})
